import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap, exhaustMap } from 'rxjs/operators';

import * as destinationActions from '../actions/index'; // Importing from index.ts
import { DestinationsService } from '../../services/destinations.service';

@Injectable()
export class DestinationsEffects {
  constructor(
    private actions$: Actions,
    private destinationsService: DestinationsService
  ) {}

  getDestinations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(destinationActions.getDestinations),
      switchMap((action) =>
        this.destinationsService
          .getDestinationDropDown(action.queryParams)
          .pipe(
            map((response) =>
              destinationActions.getDestinationsSuccess({
                data: response,
              })
            ),
            catchError((error: any) =>
              of(
                destinationActions.getDestinationsFailure({
                  error,
                })
              )
            )
          )
      )
    )
  );

  // New effect to get a destination by ID
  getDestinationById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(destinationActions.getDestinationById),
      switchMap((action) =>
        this.destinationsService
          .getDestinationById(action.id, action.category)
          .pipe(
            map((response) =>
              destinationActions.getDestinationByIdSuccess({ data: response })
            ),
            catchError((error: any) =>
              of(destinationActions.getDestinationByIdFailure({ error }))
            )
          )
      )
    )
  );

  getDomesticDestinations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(destinationActions.getDomesticDestinations),
      switchMap((action) =>
        this.destinationsService.getDestinations('domestic').pipe(
          map((response) =>
            destinationActions.getDomesticDestinationsSuccess({
              data: response,
              category: action.category,
            })
          ),
          catchError((error: any) =>
            of(
              destinationActions.getDomesticDestinationsFailure({
                error,
                category: action.category,
              })
            )
          )
        )
      )
    )
  );

  getInternationalDestinations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(destinationActions.getInternationalDestinations),
      switchMap((action) =>
        this.destinationsService.getDestinations('international').pipe(
          map((response) =>
            destinationActions.getInternationalDestinationsSuccess({
              data: response,
              category: action.category,
            })
          ),
          catchError((error: any) =>
            of(
              destinationActions.getInternationalDestinationsFailure({
                error,
                category: action.category,
              })
            )
          )
        )
      )
    )
  );
}
